import { CButton, CCol, CInput, CLabel, CRow } from "@coreui/react";
import React, { useEffect, useState } from "react";
import CommonList from "../crud/CommonList";
import { apiCall } from "src/_apiConfig/apiCall";
import { useHistory } from "react-router-dom";
// import usersData from "../users/UsersData";
const LotGoodStatus = () => {
  let history = useHistory();

  const [usersData, setuserData] = useState();
  const [loading, setloading] = useState(false);

  useEffect(() => {
    getLotDetails();
  }, []);
  const fields = [
    { key: "EMI", label: "EMI" },
    { key: "Date", _style: { width: "20%" }, label: "" },
    { key: "Goods Status ", _style: { width: "20%" }, label: "Goods Status " },
    { key: "Goods Status ", _style: { width: "20%" }, label: "Due Date " },
    { key: "Amount", _style: { width: "20%" }, label: "Amount" },
    {
      key: "Payment status",
      _style: { width: "20%" },
      label: "Payment status",
    },
  ];
  const getLotDetails = async () => {
    setloading(true);
    const header = new Headers();
    // header.append("", "");
    const response = await apiCall(`User/getCGMFOfficers`, "GET", header, null);

    if (response.status === 200) {
      const jsonobj = await response.json();
      setuserData(jsonobj);
    }
    setloading(false);
  };
  let additional = (
    <>
      <div>
        <CRow>
          <CCol xl={3}>
            <CLabel>Login Id:</CLabel> <CInput />
          </CCol>
          <CCol xl={3}>
            <CLabel>Company Name:</CLabel> <CInput />
          </CCol>
        </CRow>
        <CRow className="mt-3">
          <CCol xl={3}>
            <CLabel>Lot number:</CLabel> <CInput />
          </CCol>
          <CCol xl={3}>
            <CLabel>Purchase Rate per S.B.:</CLabel> <CInput />
          </CCol>
        </CRow>
        <CRow className="mt-3">
          <CCol xl={3}>
            <CLabel>Purchase Price :</CLabel> <CInput />
          </CCol>
        </CRow>
      </div>
    </>
  );
  return (
    <>
      <CRow>
        <CCol xl={12}>
          <CommonList
            items={usersData}
            fields={fields}
            listName="Good Status"
            loading={loading}
            additional={additional}
          />
          <CButton
            className="float-right"
            color="success"
            onClick={() => history.goBack()}
          >
            Go Back
          </CButton>
        </CCol>
      </CRow>
    </>
  );
};
export default LotGoodStatus;
